const regex = (v: any, r: any) => {
	return empty(v) ? null : r.exec(v) !== null
}

const empty = (s: any) => {
	return s === "" || s === undefined || s === null
}

const number = (v: any) => {
	const r = /^\d+$/gm
	return empty(v) ? true : regex(v, r)
}

const validator = () => {
	const app = useNuxtApp()
	const strings = {
		number: (field: string) => app.$i18n.t("validator.number", { field }),
		equal: (field: string) => app.$i18n.t("validator.equal", { field }),
		email: (field: string) => app.$i18n.t("validator.email", { field }),
		mobile: (field: string) => app.$i18n.t("validator.mobile", { field }),
		tel: (field: string) => app.$i18n.t("validator.tel", { field }),
		length: (field: string, n: any) => app.$i18n.t("validator.length", { field, n }),
		minLength: (field: string, n: any) => app.$i18n.t("validator.minLength", { field, n }),
		maxLength: (field: string, n: any) => app.$i18n.t("validator.maxLength", { field, n }),
		min: (field: string, n: any) => app.$i18n.t("validator.min", { field, n }),
		max: (field: string, n: any) => app.$i18n.t("validator.max", { field, n }),
		valid: (field: string) => app.$i18n.t("validator.valid", { field })
	}

	return {
		number,
		email(v: any) {
			const r = /^.+@.+\..+$/gm
			return empty(v) ? true : regex(v, r)
		},
		equal(v: any, t: any) {
			return empty(v) ? true : v === t
		},
		mobile(v: any) {
			const r = /^[0+]\d{10,17}$/gm
			return empty(v) ? true : regex(v, r)
		},
		tel(v: any) {
			const r = /^0\d{4,10}$/gm
			return empty(v) ? true : regex(v, r)
		},
		minLength(v: any, t: any) {
			return empty(v) ? true : v.length >= t
		},
		maxLength(v: any, t: any) {
			return empty(v) ? true : v.length <= t
		},
		length(v: any, t: any) {
			const r = new RegExp(`^.{${t}}$`, "gm")
			return empty(v) ? true : regex(v, r)
		},
		max(v: any, t: any) {
			const n = parseInt(v)
			return empty(v) ? true : number(v) && n <= t
		},
		min(v: any, t: any) {
			const n = parseInt(v)
			return empty(v) ? true : number(v) && n >= t
		},
		valid(v: any) {
			return empty(v) ? null : true
		},
		validate(value: any, field: string, validations: string): string[] {
			const a: string[] = []
			validations.split("|").forEach((o) => {
				const [k, n] = [
					...o
						.replace("]", "")
						.split("[")
						.filter((t) => t),
					null,
					null
				]
				// @ts-ignore
				const f = this[k]
				if (f && f(value, n) !== true) {
					// @ts-ignore
					const f2 = strings[k]
					a.push(f2(field, n))
				}
			})
			return a
		}
	}
}

export default validator
